import { SearchBox as AisSearchBox } from "react-instantsearch";
import React from "react";
import styled from "styled-components";
import searchIcon from "../../components/composites/SearchBar/images/search-icon.svg";
import { SearchIcon } from "../../components/composites/SearchBar/SearchBar";
import { breakpoints } from "../styledHelpers";

export default function SearchBox() {
  return (
    <StyledSearchBox
      placeholder="Search..."
      searchAsYouType={false}
      submitIconComponent={() => <SearchIcon dangerouslySetInnerHTML={{ __html: searchIcon }} />}
    />
  );
}

const StyledSearchBox = styled(AisSearchBox)`
  &.ais-SearchBox {
    width: 100%;
    position: relative;
  }
  .ais-SearchBox-input {
    width: 100%;
    height: 40px;
    padding: 0 30px 0 40px;
    appearance: none;
    font-size: 13px;
    border: 1px solid rgb(34, 34, 34);
    border-radius: 2px;
    &:focus {
      outline-offset: 0;
      outline: black solid 1px;
    }
  }
  .ais-SearchBox-reset {
    margin-left: -40px;
    background: transparent;
    border: none;
    cursor: pointer;
    width: 40px;
    height: 40px;
  }
  .ais-SearchBox-submit {
    position: absolute;
    top: 0;
    left: 0;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    border: none;
  }
  .ais-SearchBox-loadingIndicator {
    display: none;
  }
  ${breakpoints.down("sm")} {
    .ais-SearchBox-input {
      padding-left: 28px;
      padding-right: 32px;
    }
    .ais-SearchBox-reset {
      margin-left: -32px;
      width: 32px;
      height: 32px;
    }
    .ais-SearchBox-submit {
      width: 32px;
      height: 32px;
    }
  }
`;
